import ApolloClient from 'apollo-boost';

export const createClient = () => new ApolloClient();
